<template>     
<div class="card overflow-auto">	
	<div class="dash-card-header"> 
		<div class="back-link pl-2">
			<button @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg" >	
			</button>
		</div>
		<div class="title-div font-medium font-size-15"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("jt")}}</div>
		<div class="logout-link">
			<img class="" src="@/assets/logout.svg" @click="logout">
		</div>
	</div>

	  <div class="justify-center items-center">
		<div v-for="(item, index) in functions" class="ml-10" :key="index">							
			<jobtype-dropdown 
				:functionName='item.communityName'
				:functions='item.functions'
				:selectedFunctions='selectedFuntions'
				:functionsArray='functions'
				:functionsIndex='index'	
				:atLeastone='atLeastOne'			
			></jobtype-dropdown>
		</div>
		<br>
		<div v-if="error" class="form-group col-sm-12 text-center">
			<div class=" p-4 btn-danger">{{error}}</div>
		</div>
		<div v-if="update" class="form-group col-sm-12 mt-5 pb-5">
			<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("save")}}</button>
		</div>
		<div v-else class="form-group col-sm-12 mt-5 pb-5">
			<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("next")}}</button>
		</div>
	</div> 
</div>

</template>

<script>
import repository from "@/api/repository";
import jobtypeDropdown from "@/components/jobtypeDropdown";

export default {
	props: ['update'],
  	components: { jobtypeDropdown },
    data () {
        return {
			functions: {},
			error: '',
			email: this.$store.getters.user.email,
			selectedFunctions: {},
			ukey: '',
			atLeastone: false,
			nextStepCheck: false
        }
    },
	mounted() {
		window.scrollTo(0,0)
	},
    async created() {
        let user = JSON.parse(localStorage.getItem('user'))
        if (user) {
            this.ukey = user.ukey
			if (user.radius == '25' || user.radius == 0 || user.transport == '') {
				this.nextStepCheck = true
			}
        }
        try {
            let { data } = await repository.getFunctions();
		
            this.selectedFuntions = user.functions
            this.functions = data;
        } catch (error) {
            this.error = error;
        }

    },
    methods:{
        hasHistory () { return window.history.length > 2 },
        async saveForm(update = false){	
            this.error = null;     

			let temp = []
			for(let i = 0; i < this.functions.length; i++ ) {
				temp = temp.concat(this.functions[i].functions)
			}
			if (!temp.find(element => element.selected == true)) {
				this.error = 'Select at least one function'
                return;
			}

            let data = {
                functions: this.functions,
                email: this.$store.getters.user.email,
                ukey: this.ukey
            }

            try {
                await this.$store.dispatch('registerJobTypes', data);
				if(this.update && !this.nextStepCheck) { 
					await this.$router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')}});
					return;
				}
			    await this.$router.push({ name: 'registerTransportation', params: {lang: localStorage.getItem('locale')}});
            } catch (error) {
                if(error.response && error.response.data && error.response.data.message) {
                    this.error = error.response.data.message;
                }
            }
       },
        async logout(){
             this.error = null;
              try {
                  await this.$store.dispatch('logout');
                  await this.$router.push({ name: 'home' });
              } catch (error) {
                  this.error = error;
              } finally {
                  this.loading = false;
              }
         },
    }
}
</script>

<style scoped>
</style>